// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"362": "LazyIdentificationForm","616": "LazyGoogleOneTap",}[chunkId] + "." + {"362": "e5b1e22f1822f3ff","616": "d32e4e78be8a5ecf",}[chunkId] + ".js"
}